module.exports = __webpack_public_path__ + "img/abi.0b04b4d3.png";